import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { FeedbackWidget } from '../feedback/FeedbackWidget';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
import { devices } from '../styles/viewports.styles';
import { BackLink } from '../views-components/BackLink';
import { Step } from '../views/Step';
import { AppHeader } from './AppHeader';
import { AppViewComponent } from './AppViewComponent';
import { useViewContainer } from './useViewContainer';
export const ViewContainerWrapper = styled.div.withConfig({
  displayName: "BasicViewContainer__ViewContainerWrapper",
  componentId: "sc-1aau5sd-0"
})(["display:grid;grid-template-columns:1.5rem 3.125rem auto 3.125rem 1.5rem;grid-template-rows:minmax(2.5rem,max-content) 0 auto minmax( 2.5rem,max-content );grid-template-areas:'left-gutter header header header right-gutter' 'left-gutter subheader subheader subheader right-gutter' 'left-gutter main main main right-gutter' 'left-gutter submain submain submain right-gutter';min-height:100vh;padding-top:0.5rem;max-width:32.5rem;margin:0 auto;", " @media ", "{max-width:37.5rem;margin:", ";justify-content:", ";}@media ", "{grid-template-columns:2.5rem 3.125rem auto 3.125rem 2.5rem;grid-template-rows:minmax(2.5rem,max-content) 0 auto minmax( 2.5rem,max-content );max-width:100vw;margin:0 auto;justify-content:", ";}"], props => props.theme.embedded && `grid-template-rows: 5rem 0 auto 5rem 5rem;`, devices.tablet, props => props.isAcq129Step && 'auto', props => props.isAcq129Step && 'center', devices.desktop, props => props.isAcq129Step && 'initial');
const BackButton = styled.div.withConfig({
  displayName: "BasicViewContainer__BackButton",
  componentId: "sc-1aau5sd-1"
})(["display:none;grid-template-rows:auto auto;grid-area:subheader;z-index:1;@media ", "{display:initial;}"], devices.desktop);
export const BasicViewContainer = () => {
  const {
    ViewComponent,
    viewContainerProps
  } = useViewContainer();
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();
  const {
    currentStep
  } = useCurrentStep();
  const isAcq129Step = [Step.TrialPicker, Step.Pricing].includes(currentStep);

  if (!ViewComponent) {
    return null;
  }

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(ViewContainerWrapper, Object.assign({}, viewContainerProps, {
      isAcq129Step: isAcq129Step,
      children: [/*#__PURE__*/_jsx(AppHeader, {}), /*#__PURE__*/_jsx(BackButton, {
        className: "m-top-4",
        children: !isFramedCentredStep && /*#__PURE__*/_jsx(BackLink, {})
      }), /*#__PURE__*/_jsx(AppViewComponent, {
        StepViewComponent: ViewComponent
      }), /*#__PURE__*/_jsx(FeedbackWidget, {})]
    }))
  });
};